import { Media, fadeIn, mbSize } from '@foxrenderfarm/common/src/theme'
import styled, { css } from 'styled-components'
import { Placement } from './tooltip'

export const Container = styled.div`
  position: relative;
  height: fit-content;
`

export const TooltipWrapper = styled.div<{
  $background: string
  $borderColor: string
  $top: number
  $left: number
  $gap: number
  $gapMb: number
  $borderRadius: number
  $placement: Placement
}>`
  position: absolute;
  z-index: 9;
  top: ${({ $top, $gap, $placement }) =>
    `${$top + (['bottom', 'top', 'bottom-left'].includes($placement) ? $gap : 0)}px`};
  left: ${({ $left, $gap, $placement }) =>
    `${$left + (['left', 'right'].includes($placement) ? $gap : 0)}px`};
  padding: 12px 15px;
  width: fit-content;
  background: ${({ $background }) => $background};
  border: 1px solid ${({ $borderColor }) => $borderColor};
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
  animation: ${fadeIn} 300ms;
  &::before {
    ${({ $placement, $borderColor }) =>
      ($placement === 'bottom' || $placement === 'bottom-left') &&
      css`
        position: absolute;
        content: '';
        display: block;
        top: -12px;
        left: ${$placement === 'bottom' ? '50%' : '20px'};
        transform: translateX(-50%);
        border: 6px solid ${$borderColor};
        border-right-color: transparent;
        border-left-color: transparent;
        border-top-color: transparent;
      `}
  }
  &::after {
    ${({ $placement, $background }) =>
      ($placement === 'bottom' || $placement === 'bottom-left') &&
      css`
        position: absolute;
        content: '';
        display: block;
        top: -11px;
        left: ${$placement === 'bottom' ? '50%' : '20px'};
        transform: translateX(-50%);
        border: 6px solid ${$background};
        border-right-color: transparent;
        border-left-color: transparent;
        border-top-color: transparent;
      `}
  }

  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(17.5)} ${mbSize(22)};
    top: calc(
      ${({ $top, $gapMb, $placement }) =>
        `${$top}px + ${['bottom', 'top', 'bottom-left'].includes($placement) ? mbSize($gapMb) : '0px'}`}
    );
    left: calc(
      ${({ $left, $gapMb, $placement }) =>
        `${$left}px + ${['left', 'right'].includes($placement) ? mbSize($gapMb) : '0px'}`}
    );
  }
`
